
import {useMemo} from "react";
import {useListDepartmentsQuery} from "../apis/departmentApi";

import _ from "lodash";

export const useListPossibleParentDepartments = (departmentId) => {
    const {data: departments, isFetching} = useListDepartmentsQuery();
    const isUnderHierarchyOf = (childDepartment, topDepartmentId, allDepartments) => {
        if(childDepartment?.id === undefined || topDepartmentId === undefined) {
            return true; //edge case if a parent ID is not found within the list, then the whole hierarchy will be disconsidered
        } else if(childDepartment.parent === topDepartmentId) {
            return true;
        } else if(!childDepartment.parent) {
            return false;
        } else {
            return isUnderHierarchyOf(allDepartments.find(e => e?.id && e.id === childDepartment.parent), topDepartmentId, allDepartments);
        }
    }

    return useMemo(() => {
        return {
                departments: (departments || []).filter(e => e?.id !== departmentId && !isUnderHierarchyOf(e, departmentId, departments)), 
                isFetching
            };
    }, [departmentId, departments]);
}



export const useIsParentDisabled = (departmentId) => {
    const {data: departments, isFetching} = useListDepartmentsQuery();
    const isUnderDisabledHierarchy = (department, allDepartments) => {
        if(department?.id === undefined || !department.enabled) {
            return true; 
        } else if(!department.parent) {
            return false;
        } else {
            return isUnderDisabledHierarchy(allDepartments.find(e => e?.id && e.id === department.parent), allDepartments);
        }
    }

    return useMemo(() => {
        return {
            disabled: isUnderDisabledHierarchy((departments || []).find(e => e?.id === departmentId), departments), 
            isFetching
        };
    }, [departmentId, departments]);
}

